import React from "react";
import IncrementDecrement from "./IncrementDecrement";
import { TextField, TextFieldVariant } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";

type PeriodPickerProps = {
  className?: string;
  value?: number;
  setValue: (value: number | undefined) => void;
  increment: () => void;
  decrement: () => void;
  disabled?: boolean;
};

const PeriodPicker = ({
  className,
  value,
  setValue,
  increment,
  decrement,
  disabled,
}: PeriodPickerProps) => {
  return (
    <div className={clsx("flex items-center space-x-2", className)}>
      <TextField
        value={value}
        placeholder={value == undefined ? "_" : ""}
        variant={TextFieldVariant.Inlined}
        onChange={(e: any) => !disabled && setValue(Number(e.target.value))}
        disabled={disabled}
      ></TextField>
      <IncrementDecrement
        className={className}
        increment={increment}
        decrement={decrement}
        disabled={disabled}
      ></IncrementDecrement>
    </div>
  );
};

export default PeriodPicker;
